/* ============================================================
   Giggle Zone — Flexible Grid / Slider controller
   Slider mode = a REAL horizontal scroller. This adds the arrow
   buttons, autoplay, loop and the arrow enabled/disabled state.
   Grid mode needs no JS. Idempotent; re-inits on shopify:section:load.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isSliderNow(root) {
    var desktop = window.matchMedia('(min-width:900px)').matches;
    return desktop
      ? root.getAttribute('data-d-mode') === 'slider'
      : root.getAttribute('data-m-mode') === 'slider';
  }

  function pageSize(items) {
    var first = items.children[0];
    if (!first) return items.clientWidth;
    var style = getComputedStyle(items);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function visibleCount(items) {
    return Math.max(1, Math.round(items.clientWidth / pageSize(items)));
  }

  function updateArrows(root, items, prev, next) {
    if (!prev || !next) return;
    if (root.getAttribute('data-loop') === 'true') { prev.disabled = false; next.disabled = false; return; }
    var max = items.scrollWidth - items.clientWidth - 2;
    var pos = Math.abs(items.scrollLeft); // works for LTR and modern RTL
    prev.disabled = pos <= 2;
    next.disabled = pos >= max;
  }

  /* dir: +1 = advance in reading order ("next"), -1 = "prev".
     scrollBy is direction-relative, so we only flip the sign for RTL. */
  function step(root, items, dir) {
    var amount = pageSize(items) * visibleCount(items) * dir;
    var rtl = getComputedStyle(items).direction === 'rtl';
    var loop = root.getAttribute('data-loop') === 'true';
    if (loop) {
      var max = items.scrollWidth - items.clientWidth;
      var pos = Math.abs(items.scrollLeft);
      if (dir > 0 && pos >= max - 4) { items.scrollTo({ left: 0, behavior: REDUCED ? 'auto' : 'smooth' }); return; }
      if (dir < 0 && pos <= 4) { items.scrollTo({ left: rtl ? -max : max, behavior: REDUCED ? 'auto' : 'smooth' }); return; }
    }
    items.scrollBy({ left: rtl ? -amount : amount, behavior: REDUCED ? 'auto' : 'smooth' });
  }

  function init(root) {
    if (!root || root.__gzFlexReady) { if (root && root.__gzFlexResync) root.__gzFlexResync(); return; }
    root.__gzFlexReady = true;

    var items = root.querySelector('.gz-flex__items');
    if (!items) return;
    var prev = root.querySelector('.gz-flex__arrow--prev');
    var next = root.querySelector('.gz-flex__arrow--next');

    prev && prev.addEventListener('click', function () { step(root, items, -1); pause(); });
    next && next.addEventListener('click', function () { step(root, items, 1); pause(); });
    items.addEventListener('scroll', function () { updateArrows(root, items, prev, next); }, { passive: true });

    // ---- autoplay ----
    var timer = null;
    function play() {
      stop();
      if (REDUCED) return;
      if (root.getAttribute('data-autoplay') !== 'true') return;
      if (!isSliderNow(root)) return;
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
      timer = setInterval(function () {
        var max = items.scrollWidth - items.clientWidth - 4;
        var atEnd = Math.abs(items.scrollLeft) >= max;
        if (atEnd && root.getAttribute('data-loop') !== 'true') { stop(); return; }
        step(root, items, 1);
      }, speed);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var resumeT = null;
    function pause() { stop(); clearTimeout(resumeT); resumeT = setTimeout(play, 4000); }

    if (root.getAttribute('data-pause-hover') !== 'false') {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
    }
    root.addEventListener('touchstart', stop, { passive: true });

    function resync() {
      root.classList.toggle('gz-flex--has-arrows',
        !!(prev && next) && isSliderNow(root) && items.scrollWidth > items.clientWidth + 4);
      updateArrows(root, items, prev, next);
      play();
    }
    root.__gzFlexResync = resync;

    window.addEventListener('resize', debounce(resync, 200));
    resync();
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function scan(scope) { (scope || document).querySelectorAll('.gz-flex').forEach(init); }
  window.__gzFlexRescan = scan;

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', function () { scan(); })
    : scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();